import { useState } from "react";
import { labs } from "../../game/data";
import type { PlayerState } from "../../game/playerState";
import { LevelRow } from "./LevelRow";

interface Props {
  state: PlayerState;
  update: (mutate: (draft: PlayerState) => void) => void;
}

export function LabsPanel({ state, update }: Props) {
  const [filter, setFilter] = useState("");
  const q = filter.trim().toLowerCase();
  const visible = q ? labs.filter((lab) => lab.name.toLowerCase().includes(q)) : labs;

  return (
    <div className="panel">
      <input
        className="search"
        type="search"
        placeholder={`Search ${labs.length} labs…`}
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
      />
      <div className="rows">
        {visible.map((lab) => (
          <LevelRow
            key={lab.id}
            name={lab.name}
            detail={
              lab.unlock.tier ? `unlocks T${lab.unlock.tier} W${lab.unlock.wave}` : undefined
            }
            level={state.labs[lab.id] ?? 0}
            maxLevel={lab.maxLevel}
            onChange={(lvl) =>
              update((draft) => {
                draft.labs[lab.id] = lvl;
              })
            }
          />
        ))}
      </div>
    </div>
  );
}
